import React, { useState } from 'react';
import classNames from 'classnames';

import css from './Accordion.module.css'; // Optional: for styling the accordion
import AccordionPanel from './AccordionPanel';

const Accordion = ({
  panels,
  initialTab = '',
  onValueChange,
  value = null,
  multiple,
  className,
  panelClassName,
  panelLabelClassName,
  panelIconClassName,
  panelContentClassName,
  panelHeadingClassName,
}) => {
  const [activeTab, setActiveTab] = useState(initialTab);
  const isControlled = typeof onValueChange === 'function';

  const toggleTab = tab => {
    const currentValue = isControlled ? value : activeTab;
    let nextValue;

    if (multiple) {
      nextValue = [...(currentValue || [])];

      const tabIndex = nextValue.findIndex(currentTab => currentTab === tab);

      if (tabIndex === -1) {
        nextValue.push(tab);
      } else {
        nextValue.splice(tabIndex, 1);
      }
    } else {
      nextValue = currentValue === tab ? '' : tab;
    }

    if (isControlled) {
      onValueChange?.(nextValue);
    } else {
      setActiveTab(nextValue);
    }
  };

  return (
    <div className={classNames(css.accordion, className)} role="tablist">
      {panels.map(panel => (
        <AccordionPanel
          key={panel.id}
          activeTab={value || activeTab}
          {...panel}
          activateTab={() => toggleTab(panel.id)}
          className={panelClassName}
          iconClassName={panelIconClassName}
          contentClassName={panelContentClassName}
          labelClassName={panelLabelClassName}
          headingClassName={panelHeadingClassName}
        />
      ))}
    </div>
  );
};

export default Accordion;
